export const HOME = '/';
export const ABOUT_US = '/about-us';
export const OUR_SERVICES = '/our-services';
export const CAREERS = '/careers';
export const CONTACT_US = '/contact-us';